// src/components/modal/ModalBody.tsx

import { ReactNode } from 'react';

interface ModalBodyProps {
  children?: ReactNode;
  className?: string;
}

function ModalBody({
  children,
  className = '',
}: ModalBodyProps) {
  return (
    <div className={`p-5 ${className}`}>
      {children}
    </div>
  );
}

export default ModalBody;